// this is the prod docusign link, used by all envs
const docusignFormUrl = 'https://na2.docusign.net/Member/PowerFormSigning.aspx';

export class CoverpathPolicyLinkConstructor {
  static createBankAccountLink(): string {
    const powerFormId = '4c3fcc13-6892-4709-960b-060fc640df68';
    return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
  }

  static createChangeBeneficiaryLink(ownerResidentialState: string): string {
    const powerFormId =
      ownerResidentialState === 'MA' ? '4cee8304-0712-45d5-ac8f-0135158ee417' : '2701fc59-91e1-4e83-8147-58fafcf81139';
    return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
  }

  static creatChangeOwnerLink(): string {
    const powerFormId = '1cb232d0-478c-453d-a8d4-61ea5a59f7ff';
    return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
  }

  static createMailingAddressLink(newPowerFormId): string {
    const powerFormId = CoverpathPolicyLinkConstructor.useOrigPowerFormId(newPowerFormId)
      ? 'bbb8b735-4681-4cc6-8d61-013c41cd7f15'
      : newPowerFormId;

    return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
  }

  static createChangeNameLink(newPowerFormId): string {
    const powerFormId = CoverpathPolicyLinkConstructor.useOrigPowerFormId(newPowerFormId)
      ? 'f10d1f7d-1724-4ab0-bf02-d152b9f64e2c'
      : newPowerFormId;
    return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
  }

  static createChangeFaceAmountLink(newPowerFormId): string {
    const powerFormId = CoverpathPolicyLinkConstructor.useOrigPowerFormId(newPowerFormId)
      ? 'e87aa5b6-9bab-4485-bebf-47cd312b3082'
      : newPowerFormId;
    return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
  }

  static createDuplicatePolicyCertificateLink(ownerNameEmailEncode: string): string {
    const powerFormId: string = 'ffc58f07-6165-48b8-9f5e-d6f3c852fc92';
    return `${docusignFormUrl}?PowerFormId=${powerFormId}&${ownerNameEmailEncode}`;
  }

  static createCancelViaDocusignLink(
    isWholeLifePolicy: boolean,
    cpClientCancelWholePolicyPowerFormId: string,
    cpClientCancelTermPolicyPowerFormId: string
  ): string {
    let powerFormId = '';
    // whole life and term life have different power form id from launch darkly
    if (isWholeLifePolicy) {
      powerFormId = cpClientCancelWholePolicyPowerFormId;
    } else {
      powerFormId = CoverpathPolicyLinkConstructor.useOrigPowerFormId(cpClientCancelTermPolicyPowerFormId)
        ? 'a01d01e3-d0e2-4aef-b74e-dbcb8e4710b6'
        : cpClientCancelTermPolicyPowerFormId;
    }
    return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
  }

  // Return true, if orig powerform id should be used
  static useOrigPowerFormId(newPowerFormId: string) {
    return !newPowerFormId || newPowerFormId === 'orig';
  }
}
